import { render, staticRenderFns } from "./NetlinkType.vue?vue&type=template&id=4ba62ed8&scoped=true"
import script from "./NetlinkType.vue?vue&type=script&lang=js"
export * from "./NetlinkType.vue?vue&type=script&lang=js"
import style0 from "./NetlinkType.vue?vue&type=style&index=0&id=4ba62ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba62ed8",
  null
  
)

export default component.exports